"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Badge;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Container = _styledComponents["default"].div.withConfig({
  displayName: "Badge__Container",
  componentId: "sc-1x9wj4s-0"
})(function (_ref) {
  var theme = _ref.theme,
      count = _ref.count,
      showZero = _ref.showZero,
      hOffset = _ref.hOffset,
      vOffset = _ref.vOffset;
  return (0, _styledComponents.css)(["position:absolute;display:flex;justify-content:center;align-items:center;right:-", ";top:-", ";height:2.5rem;width:2.5rem;border:0.25rem solid ", ";border-radius:50%;background:", ";z-index:", ";transition:transform 125ms ease;overflow:hidden;", ""], hOffset, vOffset, theme.color.paper, theme.color.action, theme.layer.hovering, count > 0 || showZero ? (0, _styledComponents.css)(["transform:scale(1);"]) : (0, _styledComponents.css)(["transform:scale(0);"]));
});

var BadgeCount = _styledComponents["default"].span.withConfig({
  displayName: "Badge__BadgeCount",
  componentId: "sc-1x9wj4s-1"
})(function (_ref2) {
  var _ref2$theme = _ref2.theme,
      globalSizes = _ref2$theme.globalSizes,
      color = _ref2$theme.color,
      font = _ref2$theme.font;
  return (0, _styledComponents.css)(["padding:", ";font-size:", "rem;color:", ";font-weight:", ";"], globalSizes.small, font.size.caption, color.paper, font.weight.black);
});
/**
 *
 * #### A hovering container for parent components.

The `Badge`  component renders as a div in the top-right corner of its parent container. It is recommended to pass an `aria-live='polite'` attribute to the rendered element.

The `count` property is responsible for passing in the value to display, this can be either a number or a string and if the value of zero is passed, the component does not render, unless we specify the `showZero={true}` property.

The `max` property will cap the number displayed in the Badge, so if a greater value is being passed, this max value will be displayed instead.

By default, we didn't set any connection between this Badge and the parent component, however, this can be achieved by manually passing in the correct attributes to both the Badge and parent element.
The Badge can receive any additional properties, which are then applied to the label via properties spreading.  The parent element needs to receive attribute `aria-labelledby='badge-id'`, while the Badge needs to be given the correct `id`.
 */


function Badge(_ref3) {
  var _ref3$count = _ref3.count,
      count = _ref3$count === void 0 ? 0 : _ref3$count,
      _ref3$id = _ref3.id,
      id = _ref3$id === void 0 ? '' : _ref3$id,
      _ref3$hOffset = _ref3.hOffset,
      hOffset = _ref3$hOffset === void 0 ? '0.75rem' : _ref3$hOffset,
      _ref3$max = _ref3.max,
      max = _ref3$max === void 0 ? 9999 : _ref3$max,
      _ref3$showZero = _ref3.showZero,
      showZero = _ref3$showZero === void 0 ? false : _ref3$showZero,
      _ref3$vOffset = _ref3.vOffset,
      vOffset = _ref3$vOffset === void 0 ? '1rem' : _ref3$vOffset,
      rest = _objectWithoutProperties(_ref3, ["count", "id", "hOffset", "max", "showZero", "vOffset"]);

  var maxCount = Math.min(Math.max(count, 0), max);
  return /*#__PURE__*/_react["default"].createElement(Container, {
    count: maxCount,
    showZero: showZero,
    hOffset: hOffset,
    vOffset: vOffset
  }, /*#__PURE__*/_react["default"].createElement(BadgeCount, _extends({
    id: id
  }, rest), (maxCount > 0 || showZero) && maxCount));
}